export default {
      id: "ic_question_mark_black-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic_question_mark_black-usage",
      toString: function () {
        return this.url;
      }
    }